import { useMediaQuery } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import { LoadingContext, M_StateActions, NavigateContext } from 'src/M_Components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import ContactConfig from './ContactConfig';
import ContactConfigCrud from './ContactConfigCrud';

export default function ContactPage({ roles, onCreateTab, toastMessages, handleTabClose }) {
    const ctx = useContext(LoadingContext);
    const dispatch = useDispatch();
    const { t, i18n } = useTranslation();
    const { renameTab } = useContext(NavigateContext);
    const matches = useMediaQuery('(min-width:900px)');
    const M_State = useSelector((state) => state.StateKeyValue);
    const selectedTab = useSelector(s => s.StateKeyValue.find(o => o.key === 'selectedTab')?.value);
    const location = useLocation();

    const [menu, setMenu] = useState(1);
    const [selectedContact, setSelectedContact] = useState(null);
    const [refresh, setRefresh] = useState(false);

    const [id, setId] = useState(() => M_State.find(obj => obj.key === 'selectedTab')?.value || 'contact');


    //============================================================================================================
    // Function to upsert session storage data
    //============================================================================================================
    const upsertSession = (tabId, kv) => {
        const current = M_State.find(o => o.key === tabId)?.value || []; // Get current session data for the tab
        const filtered = current.filter(e => e.key !== kv.key); // Remove existing entry with the same key
        dispatch(M_StateActions.addM_State({ key: tabId, value: [...filtered, kv] })); // Add the new key-value pair
    };

    //============================================================================================================
    // Function to retrieve session storage data
    //============================================================================================================
    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true);
        const session = M_State.find(obj => obj.key === sessionID)?.value;
        if (session) {
            const m = session.find(x => x.key === 'menu')?.value;
            const contact = session.find(x => x.key === 'selectedContact')?.value;
            const ref = session.find(x => x.key === 'refresh')?.value;
            if (m) setMenu(m); // Set the menu state
            if (contact) setSelectedContact(contact); // Set the selected contact state
            if (ref !== undefined) setRefresh(ref); // Set the refresh state
        }
        ctx.setIsLoad(false);
    };

    //============================================================================================================
    // EFFECT
    // Function to rename the tab when the language changes
    //============================================================================================================
    useEffect(() => {
        if (!selectedTab) return; // Ensure selectedTab is defined
        renameTab(String(selectedTab), t('Contacts')); // Rename the tab using the translation function
    }, [selectedTab, t]);

    //============================================================================================================
    // EFFECT
    // Function to get the initial data for the contact
    //============================================================================================================
    useEffect(() => {
        getSessionStorageData(id);
        setRefresh(r => !r);
    }, [location.pathname]);

    //============================================================================================================
    // EFFECT
    // Function to persist session storage data
    //============================================================================================================
    useEffect(() => {
        if (!id) return;
        upsertSession(id, { key: 'menu', value: menu });
        upsertSession(id, { key: 'selectedContact', value: selectedContact });
        upsertSession(id, { key: 'refresh', value: refresh });
    }, [id, menu, selectedContact, refresh]);

    return (
        <div className="divGlobalSettings">
            <div style={matches ? { display: 'flex' } : {}}>
                <div className="settingsPageMainDiv">
                    <Routes>
                        <Route index element={
                            <ContactConfig // Main contact configuration component for Config table
                                roles={roles}
                                onCreateTab={onCreateTab}
                                toastMessages={toastMessages}
                                selectedContact={selectedContact}
                                setSelectedContact={setSelectedContact}
                                refresh={refresh}
                                setRefresh={setRefresh}
                            />
                        } />
                        <Route path='contactConfigCrud' element={
                            <ContactConfigCrud // Main contact configuration CRUD component
                                handleTabClose={handleTabClose}
                                toastMessages={toastMessages}
                            />
                        } />
                    </Routes>
                </div>
            </div>
        </div>
    );
}
